import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

const Podcast = ({ className }) => {
  return (
    <svg
      viewBox='0 0 390 368'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={classnames('icon', 'icon-podcast', { [className]: className })}
    >
      <path
        d='M57.1746 332.081C21.8613 296.864 0 248.227 0 194.589C0 87.3129 87.4758 0.0390625 195 0.0390625C302.524 0.0390625 390 87.3129 390 194.589C390 248.227 368.139 296.864 332.825 332.081L318.322 317.611C349.918 286.088 369.479 242.573 369.479 194.589C369.479 98.6059 291.205 20.5124 195 20.5124C98.7949 20.5124 20.5207 98.6059 20.5207 194.589C20.5207 242.573 40.0816 286.088 71.6777 317.611L57.1746 332.081ZM108.758 280.616C86.6684 258.578 72.9879 228.149 72.9879 194.589C72.9879 127.469 127.725 72.8585 195 72.8585C262.275 72.8585 317.012 127.469 317.012 194.589C317.012 228.149 303.332 258.578 281.242 280.616L295.745 295.086C321.552 269.339 337.533 233.788 337.533 194.574C337.533 116.161 273.594 52.3547 194.985 52.3547C116.375 52.3547 52.452 116.176 52.452 194.589C52.452 233.788 68.4328 269.354 94.2398 295.101L108.743 280.632L108.758 280.616ZM274.828 194.589C274.828 150.602 239.088 114.945 195 114.945C150.912 114.945 115.172 150.602 115.172 194.589C115.172 235.095 145.504 268.518 184.732 273.549V367.039H205.253V273.549C244.481 268.518 274.813 235.095 274.813 194.589H274.828Z'
        fill='currentColor'
      />
    </svg>
  );
};

Podcast.propTypes = {
  className: PropTypes.string,
};

export default Podcast;
